import { ReactNode, useState } from "react";
import { IoEye, IoEyeOff } from "react-icons/io5";

function InputField(props: {
  id?: string;
  label?: string;
  extra?: string;
  placeholder?: string;
  variant?: string;
  state?: string;
  errorMessage?: string;
  helper?: ReactNode | "string";
  disabled?: boolean;
  type?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  autoFocus?: boolean;
  readOnly?: boolean;
}) {
  const {
    label,
    id,
    extra,
    type,
    placeholder,
    variant,
    state,
    errorMessage,
    helper,
    disabled,
    value,
    onChange,
    autoFocus,
    readOnly,
    ...rest
  } = props;

  const [showPassword, setShowPassword] = useState<boolean>(false);

  const inputType =
    type === "password" ? (showPassword ? "text" : "password") : type;

  return (
    <div className={`${extra} max-h-[100px]`}>
      {label && (
        <label
          htmlFor={id}
          className={`text-sm text-navy-700 dark:text-white ${
            variant === "auth" ? "ml-1.5 font-medium" : "ml-3 font-bold"
          }`}
        >
          {label}
        </label>
      )}
      <div className="relative mt-1">
        <input
          disabled={disabled}
          type={inputType}
          id={id}
          autoFocus={autoFocus}
          placeholder={placeholder}
          readOnly={readOnly}
          onWheel={(e) => e.currentTarget.blur()}
          {...rest}
          className={`flex h-11 w-full appearance-none items-center justify-center rounded-lg border bg-white p-3 px-4 py-2.5 text-sm outline-none transition-all duration-200
        placeholder:text-gray-400 focus:border-blue-500 focus:ring-2
         focus:ring-blue-500/30 dark:bg-gray-900 dark:text-white/90
         dark:placeholder:text-white/30 dark:focus:border-blue-400 dark:focus:ring-blue-400/30 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none
${
  disabled
    ? "!cursor-not-allowed !bg-gray-100 dark:!bg-white/5"
    : state === "error"
    ? "border-red-500 focus:border-red-500 focus:ring-red-500/30 dark:border-red-400"
    : state === "success"
    ? "border-green-500 focus:border-green-500 focus:ring-green-500/30 dark:border-green-400"
    : "border-gray-300 dark:border-white/20"
}
`}
          value={value}
          onChange={onChange}
        />
        {type === "password" && (
          <span
            onClick={() => setShowPassword(!showPassword)}
            className="absolute top-6 z-30 -translate-y-1/2 cursor-pointer ltr:right-4 rtl:left-4"
          >
            {showPassword ? (
              <IoEyeOff
                size={22}
                className="fill-gray-500 dark:fill-gray-400"
              />
            ) : (
              <IoEye size={22} className="fill-gray-500 dark:fill-gray-400" />
            )}
          </span>
        )}
      </div>
      {errorMessage && (
        <p className="mt-1 text-xs text-red-500">{errorMessage}</p>
      )}
      {/* {helper && <p className="mt-1 text-xs text-gray-500">{helper}</p>} */}
      {helper && <div className="mt-1 text-xs">{helper}</div>}
    </div>
  );
}

export default InputField;
